import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M2.5 2a2 2 0 0 0-2 2v8.01a2 2 0 0 0 2 1.99H8a.5.5 0 0 0 0-1H2.5a1 1 0 0 1-.966-.741l5.64-3.471 1.326.795 7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1.5 11.105V5.383zM1.5 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M16.5 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686"
    }, null, -1)
  ]))]))
}
export default { render: render }